import { Card, CardContent } from '@/components/ui/card';
import { TrendingUp, Upload, Download, RefreshCw, Zap, Timer } from 'lucide-react';

interface ProductMetricsProps {
  eventCounts: Record<string, number>;
  events: Array<{ event_type: string; event_data: Record<string, unknown> }>;
}

const calcRate = (numerator: number, denominator: number): string => {
  if (!denominator) return '0';
  return ((numerator / denominator) * 100).toFixed(1);
};

const ProductMetricsCards = ({ eventCounts, events }: ProductMetricsProps) => {
  const uploadRate = calcRate(eventCounts['upload_success'] || 0, eventCounts['page_view'] || 0);
  const totalProcessed = (eventCounts['compression_success'] || 0) + (eventCounts['tool_success'] || 0) + (eventCounts['crop_apply'] || 0) + (eventCounts['rotate_apply'] || 0);
  const totalDownloads = (eventCounts['download_click'] || 0) + (eventCounts['download_success'] || 0) + (eventCounts['batch_download_zip'] || 0);
  const compressionRate = calcRate(totalProcessed, eventCounts['upload_success'] || 0);
  const downloadRate = calcRate(totalDownloads, totalProcessed);
  const repeatRate = calcRate(eventCounts['compress_again_click'] || 0, eventCounts['compression_success'] || 0);

  // Performance metrics from event_data
  const compEvents = events.filter(e => e.event_type === 'compression_success');
  const avgReduction = compEvents.length > 0
    ? (compEvents.reduce((acc, e) => acc + (Number(e.event_data?.reduction_percent) || 0), 0) / compEvents.length).toFixed(1)
    : '–';
  const avgTime = compEvents.length > 0
    ? (compEvents.reduce((acc, e) => acc + (Number(e.event_data?.processing_time_ms) || 0), 0) / compEvents.length).toFixed(0)
    : '–';

  const metrics = [
    { label: 'Upload Rate', value: `${uploadRate}%`, icon: Upload, color: 'text-blue-500' },
    { label: 'Compression Rate', value: `${compressionRate}%`, icon: TrendingUp, color: 'text-emerald-500' },
    { label: 'Download Rate', value: `${downloadRate}%`, icon: Download, color: 'text-violet-500' },
    { label: 'Repeat Usage', value: `${repeatRate}%`, icon: RefreshCw, color: 'text-amber-500' },
    { label: 'Avg Reducción', value: avgReduction !== '–' ? `${avgReduction}%` : '–', icon: Zap, color: 'text-rose-500' },
    { label: 'Avg Tiempo', value: avgTime !== '–' ? `${avgTime}ms` : '–', icon: Timer, color: 'text-cyan-500' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {metrics.map(m => (
        <Card key={m.label}>
          <CardContent className="pt-4 pb-4 px-4">
            <div className="flex items-center gap-2 mb-1">
              <m.icon className={`w-4 h-4 ${m.color}`} />
              <span className="text-xs text-muted-foreground">{m.label}</span>
            </div>
            <p className="text-xl font-bold">{m.value}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ProductMetricsCards;
